import { render, staticRenderFns } from "./ShowNotesModal.vue?vue&type=template&id=696c1ea3"
import script from "./ShowNotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowNotesModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports